module.exports = __webpack_public_path__ + "static/media/setting.b4514d30.png";